const appTitle = process.env.VUE_APP_TITLE || 'Sơn Tây Admin'

export default {
  HOTLINE: '0123456789',
  APP_TITLE: appTitle,
  APP_LOGO_TITLE: process.env.VUE_APP_LOGO_TITLE || appTitle,
  APP_MENUS: process.env.VUE_APP_MENUS,
  USER_ROLE_KEYS: process.env.VUE_APP_USER_ROLES,
  EDITOR_API_KEY: process.env.VUE_APP_EDITOR_API_KEY || '',
  POSITION_IDS: [1, 2, 3, 4],
  PAGE_IDS: [
    {
      id: 'home',
      link: 'https://danhgiasuky.vn'
    },
    {
      id: 'post',
      link: 'https://danhgiasuky.vn/post'
    },
    {
      id: 'library',
      link: 'https://danhgiasuky.vn/library'
    },
    {
      id: 'hierarchy',
      link: 'https://danhgiasuky.vn/hierarchy'
    },
    {
      id: 'buddhist-learning',
      link: 'https://danhgiasuky.vn/buddhist-learning'
    },
    {
      id: 'culture-space',
      link: 'https://danhgiasuky.vn/culture-space'
    }
  ],
  ACTIONS: [
    {
      key: 'GET',
      label: 'Xem thông tin'
    },
    {
      key: 'CREATE',
      label: 'Thêm thông tin'
    },
    {
      key: 'UPDATE',
      label: 'Sửa thông tin'
    },
    {
      key: 'DELETE',
      label: 'Xóa thông tin'
    }
  ],
  PRODUCT_TYPE: {
    TOUR: 'tour'
  },
  CAPACITY_MODE: {
    UNLIMITED: 'unlimited',
    FINITE: 'finite'
  }
}
